import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  addIdentityProvider(
    request: Boundaries["addIdentityProvider"]["request"],
  ): void;
}

function useAddIdentityProvider(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(selector.isAddIdentityProviderRequestPending),
    isRequestSuccess: useSelector(selector.isAddIdentityProviderRequestSuccess),
    isRequestFailure: useSelector(selector.isAddIdentityProviderRequestFailure),
    addIdentityProvider: core.addIdentityProvider,
  };
}

export { useAddIdentityProvider };
